// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3f0db5d6","210":"b0d305dc","243":"03df9823","343":"743b4990","364":"a66f977b","427":"b3504c1b","435":"64c0b5da","484":"68ee8041","487":"0b816247","529":"1762f21f","540":"1b921bf1","545":"653099b4","683":"43680012","768":"1146b3f9","843":"5d3f42de","912":"aaa01a18"}[chunkId] + ".chunk.js";
};